module.exports = __webpack_public_path__ + "img/logo.ce183e48.svg";